import { ArrowClockwise, ArrowRight, LockSimple } from "@phosphor-icons/react";

export default function LiveDemoNextAction({
  label,
  onClick,
  disabled = false,
  busy = false,
  final = false,
}) {
  const Icon = final ? ArrowClockwise : disabled ? LockSimple : ArrowRight;

  return (
    <div className="live-demo-next-action" aria-live="polite">
      <button
        type="button"
        className={`live-demo-next-action__button${disabled ? " is-locked" : " is-ready"}${final ? " is-final" : ""}`}
        onClick={onClick}
        disabled={disabled || busy}
        aria-disabled={disabled || busy}
      >
        <span>{busy ? "Preparing…" : label}</span>
        <Icon size={18} weight="bold" aria-hidden="true" />
      </button>
    </div>
  );
}
